import { useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { SUPPORTED_LANGS } from '@/i18n';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams();
  const currentLang = lang && SUPPORTED_LANGS.includes(lang) ? lang : 'en';

  useEffect(() => {
    if (!loading && !user) {
      navigate(`/${currentLang}/auth`, { state: { from: location.pathname } });
    }
  }, [loading, user, navigate, location, currentLang]);

  if (loading) {
    return (
      <div className="dark flex items-center justify-center min-h-screen bg-[#111315]" data-testid="protected-loading">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#527F19] border-t-transparent" />
      </div>
    );
  }

  if (!user) return null;
  return children;
}
